module.exports = __webpack_public_path__ + "static/img/class_icon.44400dea.png";